import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { BaseService } from '../services/base.service';
import { APPLICATION_TYPE } from '../modules/market/components/market/market.interface';


@Injectable()
export class ApplicationGuard  {
  constructor(
    protected router: Router,
    protected baseService: BaseService,
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree {
    const company = this.baseService.currentCompanyInfo;
    const key = (route.data as any).key;
    if (company) {
      if (!company.application_keys.includes(key)) {
        this.router.navigate(['/crm/marketplace'], { queryParams: { reason: 'NOT_INSTALL' } });
      }
      return true;
    }
    return true;

  }
}
